<template lang="pug">
  div.encoding-status-container(v-if="encodingJob")
    <!-- FAILED status placeholder -->
    div.encoding-status-error(v-if="encodingJob.status === 'FAILED'")
      v-icon.mr-3(color="error", size="28") mdi-alert-circle
      div.encoding-status-error-content
        div.encoding-status-error-title Video Processing Failed
        div.encoding-status-error-message {{ encodingJob.error_message || 'An error occurred during video processing.' }}
    
    <!-- PROCESSING status placeholder for all other statuses -->
    div.encoding-status-processing(v-else)
      .encoding-status-header
        v-icon.mr-2(color="primary") mdi-video-outline
        span.font-weight-medium Video Processing
      
      .encoding-status-body
        v-progress-linear(
          rounded
          height="8"
          indeterminate
          color="primary"
        )
</template>

<script>
export default {
  name: 'VideoEncodingStatus',
  props: {
    encodingJob: {
      type: Object,
      required: true
    }
  },

}
</script>

<style lang="scss" scoped>
.encoding-status-container {
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: rgba(0, 0, 0, 0.03);
}

.encoding-status-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
}

.encoding-status-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.encoding-status-error {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: rgba(244, 67, 54, 0.08);
  border-radius: 8px;
  border-left: 4px solid #f44336;
}

.encoding-status-error-content {
  flex: 1;
}

.encoding-status-error-title {
  font-size: 16px;
  font-weight: 500;
  color: #f44336;
  margin-bottom: 4px;
}

.encoding-status-error-message {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.encoding-status-processing {
  text-align: center;
}
</style>